import { Button, Flex, VStack ,Checkbox, Link} from '@chakra-ui/react'
import Block from '../components/shared/Block'
import { BsFileEarmarkText,BsCaretRightFill } from 'react-icons/bs'
import ListDocument from '../components/formAgreement/ListDocument'
import { useState } from 'react'
import {Link as ReactLink} from 'react-router-dom'

const FormAgreement = () => {
    const [check,setCheck] = useState(false)
    return (
        <Flex p="40px" direction="column" w="full">
            <Block title="กฎ ระเบียบ อาคารที่พักข้าราชการศาลยุติธรรม" icon={BsFileEarmarkText} divider={false}>
                <VStack w="full">
                    <ListDocument />
                    <Flex w="100%" p={8}>
                        <Checkbox onChange={(e) => setCheck(e.target.checked)}>ข้าพเจ้าได้ศึกษารายละเอียดของกฎ ระเบียบ อาคารที่พักข้าราชการศาลยุติธรรมเรียบร้อยแล้ว</Checkbox>
                    </Flex>
                    <Link as={ReactLink} to="/form">
                    <Button colorScheme='blue' disabled={!check} leftIcon={<BsCaretRightFill />}>ยื่นแบบคำร้อง</Button>
                    </Link>
                </VStack>
            </Block>
        </Flex>
    )
}

export default FormAgreement